module.exports = new __parcel__URL__("payment-calculator.2c728a6a.html").toString();